export default __webpack_public_path__ + "images/b8a38da3b2c25a93d77c47ee6f848f9b.svg";